/**
 * order-success.js — trang đặt hàng thành công (order-success.html, mục 26) bản DEMO.
 *
 * 1. Điền đơn vừa đặt từ localStorage `wb_last_order` (checkout.js ghi lúc bấm "Đặt hàng"):
 *    mã đơn, email, giao dự kiến, địa chỉ nhận, thanh toán, danh sách + tổng tiền.
 *    Không có đơn (mở thẳng trang) thì GIỮ NGUYÊN đơn mẫu trong HTML — đúng như guideline.
 * 2. Nút mã đơn [data-copy-order]: chép mã vào clipboard, báo toast "Đã sao chép mã đơn".
 *
 * Markup cần: [data-order-received] chứa [data-order-number], [data-order-email],
 * [data-order-delivery(-label)], [data-order-address], [data-order-payment],
 * [data-order-items], [data-order-count], [data-order-total], button[data-copy-order].
 *
 * WP/WooCommerce: phần 1 XOÁ — thankyou.php in thẳng từ $order. Giữ phần 2 (chép mã),
 * đổi data-copy-order thành $order->get_order_number() do PHP in.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var page = document.querySelector('[data-order-received]');
    if (!page) return;

    var KEY_ORDER = 'wb_last_order';
    var DOW = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'];

    function money(value) {
        return window.WBStore ? window.WBStore.money(value) : Math.round(value).toLocaleString('vi-VN') + '₫';
    }

    function esc(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
    }

    function pad(n) {
        return (n < 10 ? '0' : '') + n;
    }

    function set(selector, text) {
        var el = page.querySelector(selector);
        if (el && text) el.textContent = text;
    }

    function readOrder() {
        try {
            var raw = window.localStorage.getItem(KEY_ORDER);
            var data = raw ? JSON.parse(raw) : null;
            return data && data.number && data.items ? data : null;
        } catch (e) {
            return null;
        }
    }

    // "Hôm nay" / "Ngày mai" / "Thứ 6 24/10" — tính so với lúc MỞ trang, không phải lúc đặt,
    // để mở lại trang hôm sau không còn ghi "Hôm nay" sai.
    function dayLabel(iso) {
        var parts = String(iso).split('-');
        if (parts.length !== 3) return '';
        var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var diff = Math.round((date - today) / 86400000);
        if (diff === 0) return 'Hôm nay';
        if (diff === 1) return 'Ngày mai';
        return DOW[date.getDay()] + ' ' + pad(date.getDate()) + '/' + pad(date.getMonth() + 1);
    }

    function deliveryText(order) {
        var d = order.delivery || {};
        var text = [dayLabel(d.date), d.slot].filter(Boolean).join(', ');
        if (order.shipping && order.shipping.method === 'express') text += ' (hỏa tốc)';
        return text;
    }

    function paymentText(order) {
        var p = order.payment || {};
        if (p.method === 'card') return 'Thẻ Visa •••• ' + (p.card || '0000') + ' · ' + p.status;
        if (p.method === 'cod') return 'Thanh toán khi nhận hàng · ' + money(order.total);
        return [p.label, p.status].filter(Boolean).join(' · ');
    }

    function fill(order) {
        var number = '#' + order.number;
        set('[data-order-number]', number);
        set('[data-order-email]', order.customer && order.customer.email);
        set('[data-order-delivery-label]', order.shipping && order.shipping.method === 'pickup' ? 'Nhận tại cửa hàng' : 'Giao dự kiến');
        set('[data-order-delivery]', deliveryText(order));
        set('[data-order-address]', order.address);
        set('[data-order-payment]', paymentText(order));
        set('[data-order-count]', String(order.count));
        set('[data-order-total]', money(order.total));

        var copy = page.querySelector('[data-copy-order]');
        if (copy) copy.setAttribute('data-copy-order', order.number);

        var list = page.querySelector('[data-order-items]');
        if (list) {
            list.innerHTML = order.items.map(function (item) {
                return '<li class="order-box__item">' +
                    '<span class="thumb order-box__thumb"><img src="' + esc(item.image || 'images/products/bottle.png') + '" alt="" width="600" height="800" /></span>' +
                    '<span class="order-box__name">' + esc(item.name) + (item.year ? ' ' + esc(item.year) : '') + ' × ' + item.qty + '</span>' +
                    '<span class="order-box__price">' + money(item.price * item.qty) + '</span></li>';
            }).join('');
        }
        document.title = 'Đặt hàng thành công ' + number + ' — WINEBOSS';
    }

    // ----- Chép mã đơn -----
    // Clipboard API cần ngữ cảnh an toàn + quyền; hỏng thì lùi về execCommand trên ô ẩn
    function legacyCopy(text) {
        var area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        var ok = false;
        try {
            ok = document.execCommand('copy');
        } catch (e) {
            ok = false;
        }
        document.body.removeChild(area);
        return ok;
    }

    function copyText(text, done) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
                done(true);
            }, function () {
                done(legacyCopy(text));
            });
            return;
        }
        done(legacyCopy(text));
    }

    page.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-copy-order]') : null;
        if (!button) return;
        var code = button.getAttribute('data-copy-order');
        copyText(code, function (ok) {
            if (!window.WBToast) return;
            window.WBToast.show(ok ? 'Đã sao chép mã đơn' : 'Không chép được — mã đơn: ' + code, {
                icon: ok ? 'ph-fill ph-check-circle' : 'ph-bold ph-warning-circle'
            });
        });
    });

    // Chờ DOMContentLoaded: store.js (WBStore.money) đứng SAU file này trong bản gộp của gulp
    function init() {
        var data = readOrder();
        if (data) fill(data);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
